import { TrialFlag } from 'core/components/TrialFlag';
import style from './TitleDetail.scss';

/* eslint-disable react/prop-types */ // TODO: add props
const TitleDetail = ({ numQuestions, classCode, isTrial, expirationDate }) => {
  return (
    <div className={style.titleDetail} data-test="header">
      {classCode ? (
        <>
          <div>{classCode}</div>
          {isTrial && <TrialFlag expirationDate={expirationDate} large />}
          <div className={style.seperator} />
        </>
      ) : (
        isTrial && <TrialFlag expirationDate={expirationDate} large />
      )}
      <div>{`${numQuestions} questions`}</div>
    </div>
  );
};

export default TitleDetail;
